import React from 'react';
import { useSEO } from '../hooks/useSEO';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { Process } from '../components/Process';
import { Products } from '../components/Products';
import { RetailNetwork } from '../components/RetailNetwork';
import { CaseStudies } from '../components/CaseStudies';
import { Testimonials } from '../components/Testimonials';
import { CTASection } from '../components/CTASection';
export function Home() {
  useSEO({
    title: 'Global Procurement & Strategic Sourcing',
    description: 'UK-based independent procurement consultancy connecting global suppliers with institutional procurement opportunities worldwide. Tender support, supplier verification, and contract liaison across Africa, Asia, the Middle East, and beyond.',
    path: '/'
  });
  return <>
      <Hero data-id="element-492" />
      <Services data-id="element-493" />
      <Process data-id="element-494" />
      <Products data-id="element-495" />
      <RetailNetwork data-id="element-496" />
      <CaseStudies data-id="element-497" />
      <Testimonials data-id="element-498" />
      <CTASection data-id="element-499" />
    </>;
}